import React, { useEffect, useState } from "react";
import Modal from "src/component/Global/Modal";
import avnetAbacus from "src/assets/images/avnet-abacus-logo.png";
import avnetSilica from "src/assets/images/avnet-silica-logo.png";
import EBV from "src/assets/images/ebv-log.png";
import System from "src/helper/system";
import "../styles/product-detail.css";

const DesignHubModalPopUp = ({ showDesignHubModal = false, setShowDesignHubModal = () => { }, productDetail = {}, designData, }) => {
  const myUATSiteHost = "my.uat.avnet.com";

  const returnRedirectAbleUrl = (designItem) =>
    `/${speedBoatName}/design/${designItem.seoUrlKeyword}`;

  const speedBoatName = System.auth("speedBoat") === "T" ? "abacus" : System.auth("speedBoat") === "B" ? "ebv" : "silica";

  const getImgFromRegion = (regionName) => {
    const region = regionName.toLowerCase();
    if (region == "abacus") {
      return avnetAbacus;
    } else if (region == "ebv") {
      return EBV;
    } else {
      return avnetSilica;
    }
  };

  useEffect(() => {
    if (!showDesignHubModal) {
      setCurrentCount(5);
    }
  }, [showDesignHubModal]);

  const [currentCount, setCurrentCount] = useState(5);

  return (
    <div>
      <Modal show={showDesignHubModal} onHide={() => { setShowDesignHubModal(!showDesignHubModal); }}>
        <div className="avnet-modal avnet-modal-right design-available modal-630">
          <div className="avnet-modal-inner">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" onClick={() => {
                document.body.style.overflow = "";
                setShowDesignHubModal(false);
              }}>
                ×
              </span>
            </button>
            <div className="modal-header">
              <h4 className="modal-title text-center">Designs Available</h4>
            </div>
            <div className="modal-body">
              {(productDetail?.ERPMFRPartNumber || productDetail?.value?.ERPMFRPartNumber) && designData?.totalCount ? (
                <div className="alert alert-info">
                  <b className="text-black">
                    For part{" "}
                    {productDetail?.ERPMFRPartNumber || productDetail?.value?.ERPMFRPartNumber}
                    , there are {designData?.totalCount} possible designs
                    available:
                  </b>
                </div>
              ) : ("")}
              <div className="design-available-wrapper">
                {designData?.designs?.map((item, index) => (
                  <>
                    {index + 1 <= currentCount && (
                      <>
                        <div className="design-available-item" key={index}>
                          <div className="bs5 row">
                            <div className="col-2">
                              <img className="img-fluid" src={`https://www.avnet.com${item?.thumbnail}`} />
                            </div>
                            <div className="col-6">
                              <a href={returnRedirectAbleUrl(item)} className="text-darkgreen font-18">
                                <span title={item.designName} className="text-darkgreen" >
                                  <b>{item.designName}</b>
                                </span>
                              </a>
                              <p className="mb-0">{item.shortDescription}</p>
                            </div>
                            <div className="col-4">
                              <div className="speedboat-logo mb-3">
                                <img className="img-fluid" src={getImgFromRegion(item?.region)} />
                              </div>
                              <a target={"_blank"} href={returnRedirectAbleUrl(item)} className="bs5 btn btn-primary w-100">
                                view design
                              </a>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </>
                ))}
              </div>
              {currentCount > 5 || designData?.designs?.length > 5 ? (
                <div className="all-result position-relative" onClick={() => setCurrentCount(designData?.designs?.length)} >
                  <a className={`see-all-results text-darkgreen ${designData?.designs?.length == currentCount && "d-none"}`} >
                    LOAD MORE
                  </a>
                </div>
              ) : ("")}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default DesignHubModalPopUp;
